'use client';

import { TileMedia } from './tile-media';
import { TileWrapper } from './tile-wrapper';

interface TileProps {
  mediaUrl?: string;
  handleClick?: () => void;
  rarityClass?: string;
  isSelected?: boolean;
  isDisabled?: boolean;
  isVideo?: boolean;
  tlComponent?: React.ReactNode;
  trComponent?: React.ReactNode;
  blComponent?: React.ReactNode;
  brComponent?: React.ReactNode;
  footerComponent?: React.ReactNode;
  overlay?: React.ReactNode;
  className?: string;
}

export const Tile: React.FC<TileProps> = ({
  mediaUrl,
  handleClick,
  rarityClass = 'bg-white',
  isSelected = false,
  isDisabled = false,
  isVideo = false,
  tlComponent,
  trComponent,
  className,
  footerComponent,
  blComponent,
  brComponent,
  overlay,
}: TileProps) => {
  return (
    <TileWrapper
      className={className}
      handleClick={handleClick}
      selectedBackgroundClass={rarityClass}
      isDisabled={isDisabled}
      isSelected={isSelected}
      footer={footerComponent}
    >
      <TileMedia
        url={mediaUrl}
        isVideo={isVideo}
        hasFooter={!!footerComponent}
      />

      {tlComponent ? tlComponent : null}
      {trComponent ? trComponent : null}
      {blComponent ? blComponent : null}
      {brComponent ? brComponent : null}
      {overlay ? overlay : null}
    </TileWrapper>
  );
};
